import React, { useContext} from 'react';
import DisplayQuiz from './DisplayQuiz';
import NextButton from './NextButton';

import { Context } from '../ContextProvider'

function HomePage() {
    const {
        loading,
        quizData,
        nextButton,
        isButtonClicked,
        handleClick,
        handleNextButton
    } = useContext(Context)
    
    const question = quizData.map(quiz => <DisplayQuiz onClick={handleClick} key={quiz.capital} {...quiz}/>)

    const optionalAnswers = isButtonClicked && nextButton ? 
    quizData.map(quiz => <NextButton key={quiz.capital} {...quiz} nextButtonOnClick={handleNextButton} /> ) :
    ''
        
    return (
        <div className='container' id={nextButton ? "increase-padding" : undefined}>
            {loading === true
                ? <div>
                    <h4 className="new-quiz">Getting a new quiz!</h4>
                    <div className="fancy-spinner">
                        <div className="ring"></div>
                        <div className="ring"></div>
                    </div>
                </div>
                : <React.Fragment>
                    {question}
                    <div className="next">{optionalAnswers}</div>
                </React.Fragment>
            }
        </div>
    )
}

export default HomePage